/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function PublishStatusPublic({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} clipPath="url(#PublishStatusPublic_svg__a)"><rect width={14} height={11} x={1} y={2.5} strokeLinejoin="round" rx={2} /><path d="M10.02 6.77a2.02 2.02 0 1 1-4.04 0 2.02 2.02 0 0 1 4.04 0Z" /><path strokeLinejoin="round" d="M4.92 12.347c.345-1.117 1.355-1.876 2.495-1.876h1.17c1.14 0 2.15.759 2.496 1.876l.085.276c.134.434-.181.877-.624.877H5.458c-.443 0-.758-.443-.624-.877z" /><path d="M1.192 9.034a1.55 1.55 0 1 0 0-2.068" /><path strokeLinejoin="round" d="M4.3 13.499c.34 0 .582-.34.479-.674l-.066-.211a2.02 2.02 0 0 0-1.916-1.44h-.898c-.319 0-.624.076-.896.216" /><path d="M14.808 9.034a1.55 1.55 0 1 1 0-2.068" /><path strokeLinejoin="round" d="M11.7 13.499a.515.515 0 0 1-.479-.674l.066-.211a2.02 2.02 0 0 1 1.916-1.44h.898c.318 0 .624.076.896.216" /></g><defs><clipPath id="PublishStatusPublic_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;